/**
 * Landing Declaration Cloud API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: support@indigo.si
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CatchDataRequestBodyDto } from '../model/catchDataRequestBodyDto';
// @ts-ignore
import { CatchDataRequestDto } from '../model/catchDataRequestDto';
// @ts-ignore
import { CatchDataResponseDto } from '../model/catchDataResponseDto';
// @ts-ignore
import { CatchDataResponseDtoPagedResponseDto } from '../model/catchDataResponseDtoPagedResponseDto';
// @ts-ignore
import { ErrorProblemDetails } from '../model/errorProblemDetails';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class VesselLogBookCatchDataService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Delete CatchData
     * @param logbookId Logbook\&#39;s id
     * @param vesselId Vessel Id
     * @param catchDataId CatchData Id
     * @param tenantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (logbookId === null || logbookId === undefined) {
            throw new Error('Required parameter logbookId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete.');
        }
        if (vesselId === null || vesselId === undefined) {
            throw new Error('Required parameter vesselId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete.');
        }
        if (catchDataId === null || catchDataId === undefined) {
            throw new Error('Required parameter catchDataId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete.');
        }
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdDelete.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "tenantId", value: tenantId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/Vessel/${this.configuration.encodeParam({name: "vesselId", value: vesselId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/LogBook/${this.configuration.encodeParam({name: "logbookId", value: logbookId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/CatchData/${this.configuration.encodeParam({name: "catchDataId", value: catchDataId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get CatchData by Id
     * @param logbookId Logbook\&#39;s id
     * @param catchDataId CatchData\&#39;s Id
     * @param tenantId 
     * @param vesselId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet(logbookId: string, catchDataId: string, tenantId: string, vesselId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CatchDataResponseDto>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet(logbookId: string, catchDataId: string, tenantId: string, vesselId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CatchDataResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet(logbookId: string, catchDataId: string, tenantId: string, vesselId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CatchDataResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet(logbookId: string, catchDataId: string, tenantId: string, vesselId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (logbookId === null || logbookId === undefined) {
            throw new Error('Required parameter logbookId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet.');
        }
        if (catchDataId === null || catchDataId === undefined) {
            throw new Error('Required parameter catchDataId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet.');
        }
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet.');
        }
        if (vesselId === null || vesselId === undefined) {
            throw new Error('Required parameter vesselId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdGet.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "tenantId", value: tenantId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/Vessel/${this.configuration.encodeParam({name: "vesselId", value: vesselId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/LogBook/${this.configuration.encodeParam({name: "logbookId", value: logbookId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/CatchData/${this.configuration.encodeParam({name: "catchDataId", value: catchDataId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<CatchDataResponseDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update CatchData
     * @param logbookId Logbook\&#39;s id
     * @param vesselId Vessel\&#39;s id
     * @param catchDataId CatchData Id
     * @param tenantId 
     * @param catchDataRequestDto New CatchData information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, catchDataRequestDto?: CatchDataRequestDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CatchDataResponseDto>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, catchDataRequestDto?: CatchDataRequestDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CatchDataResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, catchDataRequestDto?: CatchDataRequestDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CatchDataResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut(logbookId: string, vesselId: string, catchDataId: string, tenantId: string, catchDataRequestDto?: CatchDataRequestDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (logbookId === null || logbookId === undefined) {
            throw new Error('Required parameter logbookId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut.');
        }
        if (vesselId === null || vesselId === undefined) {
            throw new Error('Required parameter vesselId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut.');
        }
        if (catchDataId === null || catchDataId === undefined) {
            throw new Error('Required parameter catchDataId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut.');
        }
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataCatchDataIdPut.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "tenantId", value: tenantId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/Vessel/${this.configuration.encodeParam({name: "vesselId", value: vesselId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/LogBook/${this.configuration.encodeParam({name: "logbookId", value: logbookId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/CatchData/${this.configuration.encodeParam({name: "catchDataId", value: catchDataId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<CatchDataResponseDto>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: catchDataRequestDto,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all CatchDatas
     * @param logbookId Logbook\&#39;s id
     * @param tenantId 
     * @param vesselId 
     * @param filterTermDtoListJson Json string of filter terms
     * @param orderByPropertyName 
     * @param isAsc 
     * @param pageSize 
     * @param pageNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataGet(logbookId: string, tenantId: string, vesselId: string, filterTermDtoListJson?: string, orderByPropertyName?: string, isAsc?: boolean, pageSize?: number, pageNumber?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CatchDataResponseDtoPagedResponseDto>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataGet(logbookId: string, tenantId: string, vesselId: string, filterTermDtoListJson?: string, orderByPropertyName?: string, isAsc?: boolean, pageSize?: number, pageNumber?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CatchDataResponseDtoPagedResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataGet(logbookId: string, tenantId: string, vesselId: string, filterTermDtoListJson?: string, orderByPropertyName?: string, isAsc?: boolean, pageSize?: number, pageNumber?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CatchDataResponseDtoPagedResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataGet(logbookId: string, tenantId: string, vesselId: string, filterTermDtoListJson?: string, orderByPropertyName?: string, isAsc?: boolean, pageSize?: number, pageNumber?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (logbookId === null || logbookId === undefined) {
            throw new Error('Required parameter logbookId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataGet.');
        }
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataGet.');
        }
        if (vesselId === null || vesselId === undefined) {
            throw new Error('Required parameter vesselId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (filterTermDtoListJson !== undefined && filterTermDtoListJson !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>filterTermDtoListJson, 'filterTermDtoListJson');
        }
        if (orderByPropertyName !== undefined && orderByPropertyName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderByPropertyName, 'OrderByPropertyName');
        }
        if (isAsc !== undefined && isAsc !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isAsc, 'IsAsc');
        }
        if (pageSize !== undefined && pageSize !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageSize, 'PageSize');
        }
        if (pageNumber !== undefined && pageNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pageNumber, 'PageNumber');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "tenantId", value: tenantId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/Vessel/${this.configuration.encodeParam({name: "vesselId", value: vesselId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/LogBook/${this.configuration.encodeParam({name: "logbookId", value: logbookId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/CatchData`;
        return this.httpClient.request<CatchDataResponseDtoPagedResponseDto>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a new CatchData
     * @param vesselId Vessel\&#39;s id
     * @param logbookId Logbook\&#39;s id
     * @param tenantId 
     * @param catchDataRequestBodyDto CatchData information
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataPost(vesselId: string, logbookId: string, tenantId: string, catchDataRequestBodyDto?: CatchDataRequestBodyDto, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CatchDataResponseDto>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataPost(vesselId: string, logbookId: string, tenantId: string, catchDataRequestBodyDto?: CatchDataRequestBodyDto, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CatchDataResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataPost(vesselId: string, logbookId: string, tenantId: string, catchDataRequestBodyDto?: CatchDataRequestBodyDto, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CatchDataResponseDto>>;
    public v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataPost(vesselId: string, logbookId: string, tenantId: string, catchDataRequestBodyDto?: CatchDataRequestBodyDto, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (vesselId === null || vesselId === undefined) {
            throw new Error('Required parameter vesselId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataPost.');
        }
        if (logbookId === null || logbookId === undefined) {
            throw new Error('Required parameter logbookId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataPost.');
        }
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling v1TenantIdVesselVesselIdLogBookLogbookIdCatchDataPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/v1/${this.configuration.encodeParam({name: "tenantId", value: tenantId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/Vessel/${this.configuration.encodeParam({name: "vesselId", value: vesselId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/LogBook/${this.configuration.encodeParam({name: "logbookId", value: logbookId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/CatchData`;
        return this.httpClient.request<CatchDataResponseDto>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: catchDataRequestBodyDto,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
